//generating the config array
window.picturefillCFG = window.picturefillCFG || [];
picturefillCFG.push(["algorithm", "saveData"]);
